/** DroneSquare 표식(노랑·남색 두 삼각형). 크기는 부모 스타일이 정한다. 글자 「DroneSquare」 와 함께 쓰므로 장식이다. */
export function DroneSquareMark() {
  return (
    <svg viewBox="0 0 32 33" fill="none" aria-hidden="true" focusable="false">
      <path
        d="M25.3198 3.86572L3.97754 12.0342L22.5569 26.6094L25.3198 3.86572Z"
        fill="#F0C66D"
      />
      <path
        d="M28.0226 10.9556L10.9248 17.4846L25.8092 29.1345L28.0226 10.9556Z"
        fill="#2751A3"
      />
    </svg>
  );
}
